import Cookie from '@shopify/marketing-assets/javascripts/helpers/cookie-helper';

export function setIsSubscribed(isSubscribed) {
  Cookie.set('subscribed', Boolean(isSubscribed), {path: '/'});
}

export function getIsSubscribed() {
  return Cookie.get('subscribed');
}
